import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GoogleMapsComponent } from 'app/google-maps/google-maps.component';
import { LocalStorage } from 'app/local-storage.class';
import { Region } from 'app/region.class';
import { AddressService } from 'app/services/address/address.service';
import { AuthService } from 'app/services/auth/auth.service';
import { ConfirmDialogService } from 'app/services/confirm-dialog-service/confirm-dialog.service';
import { Settings } from 'app/settings.class';
import { Utils } from 'app/utils.class';
import { map } from 'rxjs/operators';
import { AddressArea } from '../models/addressarea.interface';

@Component({
    selector: 'app-address-area',
    templateUrl: './address-area.component.html',
    styleUrls: ['./address-area.component.scss'],
    standalone: false,
})
export class AddressAreaComponent extends GoogleMapsComponent implements OnInit {
    area: AddressArea | null = null;
    loading = true;

    useStaticMapForPdf = false;
    staticMapUrl = '';

    polygonOptions = {
        clickable: false,
        strokeColor: '#0F0064',
        fillColor: '#85D1E4',
        fillOpacity: 0.35,
        strokeWeight: 2,
    };
    Utils = Utils;
    Settings = Settings;
    LocalStorage = LocalStorage;

    constructor(
        private areaService: AddressService,
        private authService: AuthService,
        protected confirmDialogService: ConfirmDialogService,
        protected cdref: ChangeDetectorRef
    ) {
        super(confirmDialogService, cdref);
    }

    ngOnInit(): void {
        super.ngOnInit();
        document.body.classList.add('screenshot');

        this.options.streetViewControl = false;

        this.watchRouteParams(
            [this.RouteParamnames.addressAreaId, this.RouteParamnames.token],
            ({ addressAreaId, token }) => {
                if (token) {
                    this.LocalStorage.setUserToken(token);
                    this.authService.getUserDetails().subscribe(user => {
                        this.LocalStorage.setUser(user.data);
                        this.loadArea(String(addressAreaId));
                    });
                } else {
                    this.loadArea(String(addressAreaId));
                }
            }
        );
    }

    loadArea(id: string): void {
        this.loading = true;
        this.areaService
            .getAreaById(id)
            .pipe(
                map(response => {
                    const area = response.data;
                    // convert the area.buildings.address.line_one to a house number and add it as area.buildings.housenumber for easier access in the template
                    area.buildings = area.buildings.map((building: any) => {
                        if (building.address?.line_one) {
                            const match = building.address.line_one.match(/(\d+)/);
                            building.housenumber = match ? match[1] : '';
                        } else {
                            building.housenumber = '';
                        }
                        return building;
                    });
                    return area;
                })
            )
            .subscribe(area => {
                console.log(area);
                this.area = area;
                this.loading = false;
                this.centerOnPolygon();
            });
    }

    centerOnPolygon(): void {
        if (this.area?.exteriorRing?.length) {
            const region = new Region(this.area.exteriorRing);
            this.zoomCenter(region.bestMapView(window.innerWidth, window.innerHeight, 20), region.centroid());

            setTimeout(() => this.readyForPuppeteer(), 5000);
        }
    }

    readyForPuppeteer(): void {
        if (!document.querySelector('readyforpuppeteer')) {
            document.body.appendChild(document.createElement('readyforpuppeteer'));
        }
    }
}
